import React from "react";
import { DropdownMenuContent as DropdownMenuContentUI } from "../dropdown-menu";
import { DropdownMenuItem } from "./DropdownMenuItem";
import { Action } from "./types";

interface DropdownMenuContentProps<DataT> {
  menuItems: Action<DataT>[];
  item?: DataT;
}

export const DropdownMenuContent = <DataT,>({
  menuItems,
  item,
}: DropdownMenuContentProps<DataT>) => {
  return (
    <DropdownMenuContentUI className="w-[224px] p-2">
      {menuItems.map((action) => {
        const shouldRender = action.showIf ? action.showIf(item) : true;

        if (!shouldRender) {
          return null;
        }

        return <DropdownMenuItem key={action.id} action={action} item={item} />;
      })}
    </DropdownMenuContentUI>
  );
};
